import { useMutation, useQuery } from "react-query";
import api from "../api";
import { API_ROUTES } from "../../utils/const";

type CollectionStatementExportPayload = {
  businessId: number | string;
  startDate: string;
  endDate: string;
  format: string;
};

const FETCH_ALL_PAYIN_COLLECTIONS = async (data) => {
  const response = await api.post(
    API_ROUTES.GET_ALL_PAYIN_COLLECTIONS,
    data,
  );
  return response.data;
};

export const getAllPayInCollectionsData = (data) => {
  return useQuery({
    queryKey: ["payInCollection", data],
    queryFn: () => FETCH_ALL_PAYIN_COLLECTIONS(data),
    enabled: !!data.business,
  });
};

const FETCH_ALL_PAYOUT_COLLECTIONS = async (data) => {
    const response = await api.post(
        API_ROUTES.GET_ALL_PAYOUT_COLLECTIONS,
        data
    )
    return response.data
}

export const getAllPayoutCollectionsData = (data) => {
    return useQuery({
        queryKey: ["payOutCollection", data],
        queryFn: () => FETCH_ALL_PAYOUT_COLLECTIONS(data),
        enabled: !!data.businessId
    })
}

const EXPORT_COLLECTION_STATEMENT = async (
  data: CollectionStatementExportPayload,
) => {
  const response = await api.post(
    API_ROUTES.EXPORT_COLLECTION_STATEMENT,
    data,
  );
  return response.data;
};

export const useCollectionStatementExport = () => {
  return useMutation({
    mutationFn: EXPORT_COLLECTION_STATEMENT,
  });
};